export class CellSaveDTO {

    ids: number[];
} 